import React, { ReactElement, useEffect, useState } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { Fournisseur } from '../../../../../common/src/entities';
import { ChampsFournisseur } from './DetailsFournisseur';
import { schemaFournisseur } from '../../../../../common/src/schemas';
import { useAlertDialog } from '../../../Utils/dialogContext';

const ENTETE_CREER_INCONNU = "Création d'un nouveau fournisseur";
const ENTETE_CREER_CONNU = 'Création du fournisseur ';
const ALERT_FOURNISSEUR = 'Fournisseur';
const ALERT_CREER_SUCESS = 'créé avec succès!';

/**
 * Page de création d'une entité fournisseur contenant les boutons
 * du haut et le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerFournisseur(props: Partial<PropsDeCreationEntite<Fournisseur>>): ReactElement {
    const bsAlert = useAlertDialog();

    const [valeursInitiales, setValeursInitiales] = useState<Fournisseur>(new Fournisseur());

    useEffect(() => {
        let title = 'Nouveau fournisseur - Dashboard';
        if (valeursInitiales.name) {
            title = `${valeursInitiales.name} - Dashboard`;
        }
        document.title = title;
    }, [valeursInitiales.name]);

    /**
     * Affiche le titre en haut du formulaire de création de fournisseur
     *
     * @param f entité Fournisseur
     * @returns html du titre
     */
    function texteEntete(f: Fournisseur): JSX.Element {
        return (
            <>
                <small className="text-muted">{f.name ? ENTETE_CREER_CONNU : ENTETE_CREER_INCONNU}</small>
                {f.name && f.name}
            </>
        );
    }

    /**
     * Callback pour un formulaire envoyé à la BD avec succès.
     * Affiche le popup de confirmation la première fois ensuite
     * seulement un crochet dans le bouton Sauvegarder
     *
     * @param f entité Fournisseur
     */
    function gererSucces(f: Fournisseur): void {
        if (valeursInitiales.id === undefined)
            bsAlert(`${ALERT_FOURNISSEUR} ${f.name} ${ALERT_CREER_SUCESS}`, 'success');
        setValeursInitiales(f);
    }

    return (
        <FormulaireCreationEntite
            entite={Fournisseur}
            schema={schemaFournisseur}
            texteEntete={texteEntete}
            succes={gererSucces}
            valeursInitiales={valeursInitiales}
            aussiEnvoyerCreated_at
            properties_to_reassign={{
                contact_par_defaut: 'fk_id_contact_par_defaut',
                contact_gestionnaire: 'fk_id_contact_gestionnaire',
                lieu: 'fk_id_lieu',
            }}
            {...props}
        >
            <ChampsFournisseur />
        </FormulaireCreationEntite>
    );
}
